var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWeatherHail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.3 11.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .st0, .st1 {\n        fill: none;\n        stroke: #02222b;\n        stroke-width: 1.5px;\n      }\n\n      .st1 {\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.5,8.9c1.7,0,3-1.3,3-3s-1.3-3-3-3-.4,0-.6,0c-.3-1.3-1.5-2.2-2.9-2.2s-2.6,1-2.9,2.2c-.1,0-.3,0-.4,0-1.7,0-3,1.3-3,3s1,2.7,2.4,2.9c.2,0,7.2,0,7.4,0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.4,
    y1: 11.1,
    x2: 8.4,
    y2: 11.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11,
    y1: 11.1,
    x2: 11,
    y2: 11.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 5.9,
    y1: 11.1,
    x2: 5.9,
    y2: 11.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3.3,
    y1: 11.1,
    x2: 3.3,
    y2: 11.1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeatherHail);
export default __webpack_public_path__ + "static/media/icon_weather_hail.400b41f5c093cf2ebf8673f562bf0ae7.svg";
export { ForwardRef as ReactComponent };